import type { CSSProperties } from "react";
import type { ThemeTokens } from "./types";
import { isHexDark } from "../../../Utils/HelperFunction/HelperFunction";

export { isInsideWebsiteTemplatePage } from "../../../Utils/websiteTemplateGuards";

/** CSS custom properties for embedded LiB feed/search under the website template. */
export function templateFeedSurfaceCssProperties(
  T: ThemeTokens,
): CSSProperties {
  return {
    ["--mte-wts-font-family" as string]: T.body,
    ["--template-background" as string]: T.bg,
    ["--template-text-color" as string]: T.ink,
    ["--template-button-bg" as string]: T.surface,
    ["--template-button-text" as string]: T.ink,
    ["--template-font-family" as string]: T.body,
    ["--social-icon-color" as string]: isHexDark(T.bg) ? "#FFFFFF" : "#000000",
    ["--tpl-font-head" as string]: T.display,
    ["--tpl-font-stack" as string]: T.body,
    ["--font-family" as string]: T.body,
    ["--text-color" as string]: T.ink,
    ["--tpl-ink" as string]: T.ink,
    ["--tpl-muted" as string]: T.muted,
    ["--tpl-bg" as string]: T.bg,
  };
}
